import React, { forwardRef } from 'react';
import { ReactEditor, useSlateStatic } from 'slate-react';
import classnames from 'classnames';

const Content = forwardRef(({ children, element, ...attributes }, ref) => {
	// Get editor's instance
	const editor = useSlateStatic();

	// Get readonly state
	const readOnly = ReactEditor.isReadOnly(editor);

	// Concat content classname
	const contentClassName = classnames(
		'flex flex-col w-full text-base leading-7 text-neutral-800 dark:text-white transition-colors',
		!readOnly && 'py-2 px-3 border border-neutral-200 dark:border-neutral-700 rounded-lg'
	);

	return (
		<div
			ref={ref}
			{...attributes}
			className={contentClassName}
		>
			{children}
		</div>
	);
});

export default Content;